import userAppModel from "@/api/user_app.model";
import { Module } from "vuex";
import { login, logout } from "../../api/_auth";

const TOKEN_STORAGE_KEY = "token";

const authModule: Module<any, any> = {
	namespaced: true,
	state: {
		activeUser: JSON.parse(localStorage.getItem("activeUser") || "{}"),
		_token: null,
	},
	getters: {
		token(state): string {
			if (!state._token) {
				state._token = sessionStorage.getItem(TOKEN_STORAGE_KEY) ?? localStorage.getItem(TOKEN_STORAGE_KEY);
			}
			return state._token;
		},
		isLoggedIn(state, getters): boolean {
			return !!getters.token;
		},
	},
	mutations: {
		SET_TOKEN(state, { token, shouldPersist }: { token: string; shouldPersist?: boolean }) {
			state._token = token;
			if (shouldPersist) {
				localStorage.setItem(TOKEN_STORAGE_KEY, token);
			} else {
				sessionStorage.setItem(TOKEN_STORAGE_KEY, token);
			}
			if (token === null) {
				localStorage.removeItem(TOKEN_STORAGE_KEY);
				sessionStorage.removeItem(TOKEN_STORAGE_KEY);
			}
		},
		SET_USER_DATA(state, userData) {
			state.activeUser = { ...userData };
			localStorage.setItem("activeUser", JSON.stringify(state.activeUser));
		},
	},
	actions: {
		async login(
			{ commit },
			{ email, password, shouldPersistSession }: { email: string; password: string; shouldPersistSession?: boolean },
		) {
			const { token, user } = await login({ email, password });

			commit("SET_TOKEN", { token, shouldPersist: shouldPersistSession });
			commit("SET_USER_DATA", { ...user });
		},

		async logout({ commit, getters }) {
			try {
				if (getters.token) {
					await logout();
				}
			} catch (error) {
				console.error(error);
			}
			commit("SET_TOKEN", { token: null });
			commit("SET_USER_DATA", null);
		},
	},
};

export default authModule;
